export const OBJECT_TYPE = {
  MANAGEMENT: "management",
  ORGANIZATION: "organization",
  PROJECT: "project",
  LIBRARY_ISSUE: "libraryIssue",
  ORGANIZATION_ISSUE: "organizationIssue",
  MEDIA: "media",
  STAKEHOLDER: "stakeholder",
  SUPERPROMPTS: "superprompts",
  CUSTOM_FIELD: "customField",
  USER_GROUP: "user_group",
} as const;
